import { createSlice } from "@reduxjs/toolkit";
import { ReduxStore } from "../../../../store";

export interface StarterLayoutStoreSlice {
  sidebarShow: boolean;
  sidebarUnfoldable: boolean;
  asideShow: boolean;
  theme: string;
}

const initialState: StarterLayoutStoreSlice = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  theme: "light",
};

const starterLayoutSlice = createSlice({
  name: "starterLayout",
  initialState,
  reducers: {
    storeStarterSetLayout: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
});

// Actions
export const { storeStarterSetLayout: storeStarterSetLayout } =
  starterLayoutSlice.actions;

// Selectors
export const storeStarterSelectLayout = (state: ReduxStore) =>
  state.starterLayout;

export const storeStarterSelectSidebarShow = (state: ReduxStore) =>
  state.starterLayout.sidebarShow;

export const storeStarterSelectSidebarUnfoldable = (state: ReduxStore) =>
  state.starterLayout.sidebarUnfoldable;

export const storeStarterSelectAsideShow = (state: ReduxStore) =>
  state.starterLayout.asideShow;

export const storeStarterSelectTheme = (state: ReduxStore) =>
  state.starterLayout.theme;

// Reducer
export default starterLayoutSlice.reducer;
